import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { SetCanonicalTag } from './services/helpers';

SetCanonicalTag(window.location.protocol, window.location.hostname);

const ErrorBoundary = React.lazy(
  () => import('./components/boundary').then(module => ({ default: module.ErrorBoundary }))
);
const P2GApp = React.lazy(
  () => import('@parcel2go/peacock-legacy-app/dist/contextProvider').then(module => ({ default: module.P2GApp }))
);
const App = React.lazy(() => import('./App'));

ReactDOM.render(
  <Suspense fallback={<React.Fragment>Loading...</React.Fragment>}>
    <ErrorBoundary>
      <P2GApp authentication socket>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </P2GApp>
    </ErrorBoundary>
  </Suspense>,
  document.getElementById('root')
);